// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"8f42e57b","453":"4e77b57b","485":"c74abc4b","818":"b68b376b","923":"3e9d864e"}[chunkId] + ".chunk.js";
};